import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { routerMiddleware } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import { promiseMiddleware, localStorageMiddleware, saveLastViewedEntity } from './middleware';
import reducer from './reducer';

const RouterMiddleware = routerMiddleware(createBrowserHistory());

const getMiddleware = () => applyMiddleware(RouterMiddleware, promiseMiddleware, localStorageMiddleware, saveLastViewedEntity, thunk);

const store = createStore(
  reducer,
  composeWithDevTools(getMiddleware()),
);

export default store;
